<template>
  <!-- 主容器 (需求1&2) -->
  <div class="w-full h-auto relative">
    <!-- 上部分容器 -->
    <div class="relative w-full h-auto px-[4.27vw] py-[6.4vw] bg-[#1E202C]">
      <!-- 优化后的内容容器 -->

      <!-- 上侧联系方式 -->
      <div class="w-auto left-0 relative flex flex-col items-start">
        <!-- 公司名称 -->
        <div class="flex flex-col items-start gap-[2.13vw]">
          <div
            class="text-left text-white text-[3.73vw] font-bold font-harmony"
          >
            西安蓝悦教育科技有限公司
          </div>
          <div
            class="text-left text-[#F28334] text-[3.73vw] font-bold font-harmony"
          >
            科学育人&nbsp;&nbsp;&nbsp;&nbsp;启发开智
          </div>
        </div>

        <!-- 社交媒体区域 -->
        <div
          class="relative flex items-center w-full h-[32.8vw] py-auto gap-[4.27vw]"
        >
          <!-- 联系电话 -->
          <div class="relative flex flex-col my-auto gap-[1.87vw]">
            <div
              class="text-left text-[#FFFFFF] text-[3.2vw] font-bold font-harmony"
            >
              咨询电话(Tel) :
            </div>
            <div
              class="text-left text-white text-[5.33vw] font-normal font-ddin uppercase"
            >
              400 0336 691
            </div>
          </div>

          <div class="size-[20.8vw] relative object-cover">
            <img class="size-full" src="@/assets/images/Footer/weixin.png" />
          </div>
          <div class="size-[20.8vw] relative object-cover">
            <img class="size-full" src="@/assets/images/Footer/douyin.png" />
          </div>
        </div>

        <!-- 地址信息 -->
        <div
          class="flex justify-start text-left text-[#FFFFFFCC] text-[2.93vw] font-normal font-harmony"
        >
          西安市沣东新城沣东大道2196号沣东自贸新天地文创街区2C
        </div>
      </div>
      <!-- 分割线 -->
      <div class="w-full h-[0.05vw] relative my-[6.4vw] bg-[#313131]"></div>
      <!-- 下侧链接区域 -->
      <div class="relative flex justify-between">
        <!-- 名校合作 -->
        <div class="flex flex-col items-center gap-[2vw]">
          <div
            class="text-left justify-center text-white text-[3.73vw] font-bold font-harmony"
          >
            名校合作
          </div>
          <div class="flex flex-col gap-[2.13vw]">
            <div
              v-for="(school, index) in schools"
              :key="index"
              class="flex items-center gap-[2.13vw]"
            >
              <img class="size-[6.4vw] object-cover" :src="school.icon" />
              <a
                :href="school.url"
                class="text-left justify-start text-[#FFFFFFCC] text-[2.93vw] font-normal font-harmony"
              >
                {{ school.name }}
              </a>
            </div>
          </div>
        </div>

        <!-- 赛证合作 -->
        <div class="flex flex-col items-center gap-[2vw]">
          <div
            class="text-left justify-start text-white text-[3.73vw] font-bold font-harmony"
          >
            赛证合作单位
          </div>
          <div class="flex flex-col gap-[2.13vw]">
            <div
              v-for="(org, index) in organizations"
              :key="index"
              class="flex items-center gap-[2.13vw]"
            >
              <img class="size-[6.4vw] object-cover" :src="org.icon" />
              <a
                :href="org.url"
                class="text-left justify-start text-[#FFFFFFCC] text-[2.93vw] font-normal font-harmony"
              >
                {{ org.name }}
              </a>
            </div>
          </div>
        </div>

        <!-- 友情链接 -->
        <div class="flex flex-col items-center gap-[2vw]">
          <div
            class="text-left justify-start text-white text-[3.73vw] font-bold font-harmony"
          >
            友情链接
          </div>
          <div class="flex flex-col gap-[2.13vw]">
            <div
              v-for="(link, index) in links"
              :key="index"
              class="flex items-center gap-[2.13vw]"
            >
              <a
                :href="link.url"
                class="h-[6.4vw] flex items-start text-left justify-start text-[#FFFFFFCC] text-[2.93vw] font-normal font-harmony"
              >
                {{ link.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 下部分版权信息 -->
    <div class="w-full h-[11.47vw] bg-[#171925] flex items-center">
      <div class="w-full px-[4.27vw] flex justify-between items-center">
        <div
          class="text-left text-[#FFFFFFA6] text-[2.93vw] font-normal font-harmony"
        >
          西安蓝悦教育科技有限公司 版权所有
        </div>
        <div
          class="text-right text-[#FFFFFFA6] text-[2.93vw] font-normal font-harmony"
        >
          陕ICP备2025064734号-2
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mobile_Footer",
  data() {
    return {
      links: [
        { name: "蓝悦官网", url: "https://www.lanyve.com" },
        { name: "其他链接", url: "https://www.bing.com" },
      ],
      schools: [
        {
          name: "陕西师范大学",
          icon: require("@/assets/images/Footer/sxsfdx.png"),
          url: "https://www.snnu.edu.cn",
        },
        {
          name: "西安交通大学",
          icon: require("@/assets/images/Footer/xajtdx.png"),
          url: "https://www.xjtu.edu.cn",
        },
        {
          name: "西北工业大学",
          icon: require("@/assets/images/Footer/xbgydx.png"),
          url: "https://www.nwpu.edu.cn",
        },
      ],
      organizations: [
        {
          name: "中国航空运动协会",
          icon: require("@/assets/images/Footer/zghkxh.png"),
          url: "https://www.asfc.org.cn",
        },
        {
          name: "中国民航局",
          icon: require("@/assets/images/Footer/zgmhj.png"),
          url: "http://www.caac.gov.cn",
        },
        {
          name: "中国航空学会",
          icon: require("@/assets/images/Footer/zghkxh.png"),
          url: "http://www.csaa.org.cn",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* 页脚样式 */
</style>